var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFabQrcodeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 14V13H10V10H13V12H15V14H14V16H12V18H10V15H12V14H13ZM18 18H14V16H16V14H18V18ZM0 0H8V8H0V0ZM2 2V6H6V2H2ZM10 0H18V8H10V0ZM12 2V6H16V2H12ZM0 10H8V18H0V10ZM2 12V16H6V12H2ZM15 10H18V12H15V10ZM3 3H5V5H3V3ZM3 13H5V15H3V13ZM13 3H15V5H13V3Z",
    fill: "#0956A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFabQrcodeIcon);
export default __webpack_public_path__ + "static/media/fab-qrcode-icon.b96d834052616ccedc74a6e3e7c18b45.svg";
export { ForwardRef as ReactComponent };